import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_DEDUCTION_CATEGORY = gql`
  mutation CreateMasterDataDeductionCategory(
    $params: CreateMasterDataDeductionTypeCategoryInput!
  ) {
    createMasterDataDeductionCategory(params: $params) {
      categoryId
      categoryName
      categoryKey
      isActive
      isLinked
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const UPDATE_MASTER_DATA_DEDUCTION_CATEGORY = gql`
  mutation UpdateMasterDataDeductionCategory(
    $params: UpdateMasterDataDeductionTypeCategoryInput!
  ) {
    updateMasterDataDeductionCategory(params: $params) {
      categoryId
      categoryName
      categoryKey
      isActive
      isLinked
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const DELETE_MASTER_DATA_DEDUCTION_CATEGORIES = gql`
  mutation DeleteMasterDataDeductionCategories(
    $params: DeleteMasterDataDeductionTypeCategoriesInput!
  ) {
    deleteMasterDataDeductionCategories(params: $params) {
      deletedCount
      blockedCount
      blockedIds
      message
    }
  }
`;
